import React from "react";

export default function Box({ style, children }) {
  return <div style={{ marginBottom: "2rem", paddingTop: "1rem", ...style }}>{children}</div>;
}
